import Typography from "typography";

const typography = new Typography({ 
	baseFontSize: '18px',
	baseLineHeight: 1.5,
	bodyFontFamily: ['Roboto Slab', 'sans-serif'],
	bodyWeight: '300',
	googleFonts: [
		{
			name: 'PT Sans',
			styles: [
				'400',
				'700',
			]
		},
		{
			name: 'Roboto Slab',
			styles: [
				'300',
				'400',
				'700',
			]
		},
	],
	headerFontFamily: ['Roboto Slab', 'sans-serif'],
	headerWeight: '300',
	scaleRatio: 2.5,
});

export default typography;


// WEBPACK FOOTER //
// ./src/utils/typography.js